import { createContext } from 'react'

const MultipleOrdersContext = createContext()

export default MultipleOrdersContext